var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefreshSymbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 473.677 473.677",
    style: {
      enableBackground: "new 0 0 473.677 473.677"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#344E5D"
    },
    d: "M0,236.842C0,106.028,106.036,0,236.835,0c130.807,0,236.842,106.028,236.842,236.842 c0,130.799-106.036,236.835-236.842,236.835C106.036,473.677,0,367.641,0,236.842z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F7F7F7"
    },
    d: "M382.648,161.894c-2.393-4.645-14.031-15.284-33.664-5.621s-10.149,30.889-10.149,30.889 c7.318,15.003,11.439,31.861,11.439,49.68c0,62.645-50.787,113.436-113.44,113.436c-62.645,0-113.436-50.791-113.436-113.436 c0-58.64,44.486-106.873,101.537-112.819v29.397c0,0-0.079,1.758,1.743,2.865c1.821,1.111,3.646,0,3.646,0l94.106-55.45 c0,0,2.113-1.111,2.113-3.276c0-1.791-2.113-3.063-2.113-3.063l-93.792-55.14c0,0-2.139-1.529-4.042-0.789 c-1.9,0.737-1.66,3.328-1.66,3.328v31.495c-84.967,6.103-152.017,76.916-152.017,163.449c0,90.531,73.389,163.92,163.917,163.92 c90.531,0,163.924-73.389,163.924-163.92C400.759,209.831,394.218,184.357,382.648,161.894z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F7F7F7"
    },
    cx: 236.85,
    cy: 236.85,
    r: 21.977
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshSymbol);
export default __webpack_public_path__ + "static/media/refresh-symbol.11ef5cd452e3366d93909c445cb51ba1.svg";
export { ForwardRef as ReactComponent };